var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat',{attrs:{"tipo":5,"user":_vm.id_pedido,"momento":2,"finalizado":_vm.detalle.estado == 32,"fecha-finalizado":_vm.detalle.fecha_ult_reclamo},on:{"actualizar-lectura":_vm.actualizarLectura}})}
var staticRenderFns = []

export { render, staticRenderFns }